import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import { useTrainer } from './useTrainer';

type Trainer = ReturnType<typeof useTrainer>;

const TrainerCtx = createContext<Trainer | null>(null);

/** Состояние тренировки живёт над маршрутизатором: маршруты сменяются, а
 *  очередь заданий и буфер попыток обязаны их пережить.
 *
 *  Профиль приходит доводом и обязан задавать `key` этому компоненту:
 *  смена профиля — это перемонтирование, а не новый довод в тот же
 *  экземпляр. */
export function TrainerProvider({
  profileId,
  children,
}: {
  profileId: string;
  children: ReactNode;
}) {
  const trainer = useTrainer(profileId);
  return <TrainerCtx.Provider value={trainer}>{children}</TrainerCtx.Provider>;
}

export function useTrainerContext(): Trainer {
  const trainer = useContext(TrainerCtx);
  if (!trainer) throw new Error('useTrainerContext вызван вне TrainerProvider');
  return trainer;
}
